// Forces the designs' "reduced motion" branch: no travel distances, near-instant transitions,
// no ambient/looping effects. On this project's target machines (Windows server / RDP, software
// rendering) framer-motion's JS animations stall mid-way, which looks jerky and can leave content
// half-animated. Instant, stable rendering is smoother than a stalled animation.
export const useReducedMotion = () => true;
